import { createAction } from "@reduxjs/toolkit"
import TYPES from "../types"

export const initialState = {
    module: "assets",
    assets: {
        datatable: {
            data: [],
            filteredData: [],
            meta: {},
        },
    },
}

export const setModule = createAction(TYPES.SET_CURRENT_MODULE)
